// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function ({ store, redirect, route }) {
  if (route.query?.id) {
    redirect(`/verificador?id=${route.query?.id}`)
  } else {
    redirect(`/verificador`)
  }
}
